const rateOffPeak = () => {
  return {
    name: 'Schedule 1G',
    title: 'Residential Service (Experimental)',
    rateElements: [
      // Fixed Monthly Charge
      {
        rateElementType: 'FixedPerMonth',
        name: 'Basic Customer Charge',
        rateComponents: [
          {
            charge: 7.58,
            name: 'Basic Customer Charge',
          },
        ],
      },
      // Energy Charges for Distribution kWh
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution kWh Charge - Summer',
        rateComponents: [
          {
            charge: 0.0260649, // 2.60649¢ per kWh
            months: [4, 5, 6, 7, 8], // May - September
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [15, 16, 17], // 15:00 - 17:00
            name: 'Summer On-Peak kWh Charge',
          },
          {
            charge: 0.011572, // 1.15720¢ per kWh
            months: [4, 5, 6, 7, 8], // May - September
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [
              6, 7, 8, 9, 10, 11, 12, 13, 14, 18, 19, 20, 21, 22, 23,
            ], // 06:00-14:00, 18:00-23:00
            name: 'Summer Off-Peak kWh Charge',
          },
          {
            charge: 0.0100527, // 1.00527¢ per kWh
            months: [4, 5, 6, 7, 8], // May - September
            daysOfWeek: [0, 6], // Sun, Sat
            hourStarts: [0, 1, 2, 3, 4, 5], // 00:00-05:00
            name: 'Summer Weekend Super Off-Peak kWh Charge',
          },
          {
            charge: 0.0100527, // 1.00527¢ per kWh
            months: [4, 5, 6, 7, 8], // May - September
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [0, 1, 2, 3, 4, 5], // 00:00-05:00
            name: 'Summer Super Off-Peak kWh Charge',
          },
          {
            charge: 0.011572, // 1.15720¢ per kWh
            months: [4, 5, 6, 7, 8], // May - September
            daysOfWeek: [0, 6], // Sun, Sat
            hourStarts: [
              6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
            ], // 06:00-23:00
            name: 'Summer Weekend Off-Peak kWh Charge',
          },
          {
            charge: 0.121772, // 12.1772¢ per kWh
            months: [4, 5, 6, 7, 8], // May - September
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [15, 16, 17], // 15:00 - 17:00
            name: 'Summer On-Peak Electricity Supply Charge',
          },
          {
            charge: 0.000146, // 0.0146¢ per kWh
            months: [4, 5, 6, 7, 8], // May - September
            daysOfWeek: [0, 1, 2, 3, 4, 5, 6], // All days
            hourStarts: [0, 1, 2, 3, 4, 5], // 00:00-05:00
            name: 'Summer Super Off-Peak Electricity Supply Charge',
          },
          {
            charge: 0.012084, // 1.2084¢ per kWh
            months: [4, 5, 6, 7, 8], // May - September
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [
              6, 7, 8, 9, 10, 11, 12, 13, 14, 18, 19, 20, 21, 22, 23,
            ], // 06:00-15:00, 18:00-23:00
            name: 'Summer Off-Peak Electricity Supply Charge',
          },
          {
            charge: 0.012084, // 1.2084¢ per kWh
            months: [4, 5, 6, 7, 8], // May - September
            daysOfWeek: [0, 6], // Sun,Sat
            hourStarts: [
              6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
            ], // 06:00-23:00
            name: 'Summer Weekend Off-Peak Electricity Supply Charge',
          },
          {
            charge: 0.00146, // 0.1460¢ per kWh
            months: [4, 5, 6, 7, 8], // May - September
            daysOfWeek: [0, 6], // Sun,Sat
            hourStarts: [0, 1, 2, 3, 4, 5], // 00:00-05:00
            name: 'Summer Weekend Super Off-Peak Electricity Supply Charge',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution kWh Charge - Winter',
        rateComponents: [
          {
            charge: 0.0224969, //  2.24969¢ per kWh
            months: [9, 10, 11, 0, 1, 2, 3], // October - April
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [6, 7, 8, 9, 17, 18, 19, 20], // 06:00-09:00, 17:00-20:00
            name: 'Winter On-Peak kWh Charge',
          },
          {
            charge: 0.0120428, // 1.20428¢ per kWh
            months: [9, 10, 11, 0, 1, 2, 3], // October - April
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [5, 9, 10, 11, 12, 13, 14, 15, 16, 20, 21, 22, 23], // 05:00, 9:00-16:00, 20:00-23:00
            name: 'Winter Off-Peak kWh Charge',
          },
          {
            charge: 0.0120428, // 1.20428¢ per kWh
            months: [9, 10, 11, 0, 1, 2, 3], // October - April
            daysOfWeek: [0, 6], // Sun,Sat
            hourStarts: [
              6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
            ], // 06:00-23:00
            name: 'Winter Weekend Off-Peak kWh Charge',
          },
          {
            charge: 0.0115272, // 1.15272¢ per kWh
            months: [4, 5, 6, 7, 8], // May - Sep
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [0, 1, 2, 3, 4, 5], // 00:00-05:00
            name: 'Winter Super Off-Peak kWh Charge',
          },
          {
            charge: 0.0115272, // 1.15272¢ per kWh
            months: [4, 5, 6, 7, 8], // May - Sep
            daysOfWeek: [0, 6], // Sun,Sat
            hourStarts: [0, 1, 2, 3, 4, 5], // 0:00-05:00
            name: 'Winter Weekend Super Off-Peak kWh Charge',
          },
          {
            charge: 0.09486, // 9.4860¢ per kWh
            months: [9, 10, 11, 0, 1, 2, 3], // October - April
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [6, 7, 8, 9, 17, 18, 19, 20], // 06:00-09:00, 17:00-20:00
            name: 'Winter On-Peak Electricity Supply Charge',
          },
          {
            charge: 0.023199, // 2.3199¢ per kWh
            months: [9, 10, 11, 0, 1, 2, 3], // October - April
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [9, 10, 11, 12, 13, 14, 15, 16, 21, 22, 23], // 09:00-16:00, 20:00-23:00
            name: 'Winter Off-Peak Electricity Supply Charge',
          },
          {
            charge: 0.023199, // 2.3199¢ per kWh
            months: [9, 10, 11, 0, 1, 2, 3], // October - April
            daysOfWeek: [0, 6], // Sun, Sat
            hourStarts: [
              6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
              23,
            ], // 06:00-23:00
            name: 'Winter Weekend Off-Peak Electricity Supply Charge',
          },
          {
            charge: 0.020143, // 2.0143¢ per kWh
            months: [9, 10, 11, 0, 1, 2, 3], // October - April
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [0, 1, 2, 3, 4, 5], // 00:00-05:00
            name: 'Winter Super Off-Peak Electricity Supply Charge',
          },
          {
            charge: 0.020143, // 2.0143¢ per kWh
            months: [9, 10, 11, 0, 1, 2, 3], // October - April
            daysOfWeek: [0, 6], // Sun, Sat
            hourStarts: [0, 1, 2, 3, 4, 5], // 00:00-05:00
            name: 'Winter Weekend Super Off-Peak Electricity Supply Charge',
          },
          {
            charge: 0.0097, // .97000¢ per kWh
            months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // January - December
            daysOfWeek: [0, 1, 2, 3, 4, 5, 6], // Sunday - Saturday
            hourStarts: [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23,
            ], // All
            name: 'Transmission kWh Charge',
          },
        ],
      },
    ],
  };
};

export default rateOffPeak;
